import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const OptionAccordion = ({ title, options, value, onChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const activeOption = options.find(
    (opt) => String(opt.value) === String(value),
  );
  const activeLabel = activeOption ? activeOption.label : '';

  const handleSelect = (selectedValue) => {
    onChange(selectedValue);
  };

  return (
    <div className="mobile-option-accordion py-3 border-bottom">
      <button
        type="button"
        className="btn btn-link w-100 p-0 text-left d-flex justify-content-between align-items-center text-dark text-decoration-none shadow-none disable-focus-styles"
        onClick={() => setIsExpanded(!isExpanded)}>
        <div className="d-flex align-items-center" style={{ fontSize: '14px' }}>
          <span className="font-weight-bold">{title}:</span>
          {!isExpanded && (
            <span className="ml-1 text-muted">{activeLabel}</span>
          )}
        </div>
        <span style={{ fontSize: '6px' }}>{isExpanded ? '▲' : '▼'}</span>
      </button>

      {isExpanded && (
        <div
          className="mt-3 d-flex flex-wrap justify-content-center"
          style={{ gap: '8px' }}>
          {options.map((option) => {
            if (!option) return null;
            const isSelected = String(option.value) === String(value);

            return (
              <label
                key={option.value}
                className={classNames('horizontal-option-card m-0', {
                  selected: isSelected,
                  disabled: option.disabled,
                })}
                style={
                  option.disabled
                    ? {
                        opacity: 0.5,
                        pointerEvents: 'none',
                        cursor: 'not-allowed',
                      }
                    : { cursor: 'pointer' }
                }>
                <input
                  type="radio"
                  className="sr-only"
                  name={`mobile-${title.replace(/\s+/g, '-')}`}
                  value={option.value}
                  checked={isSelected}
                  onChange={() => handleSelect(option.value)}
                />

                {option.iconClass && (
                  <span
                    className={classNames(
                      'horizontal-option-icon',
                      option.iconClass,
                    )}
                    aria-hidden="true"></span>
                )}

                <div className="w-100 text-center">
                  <span>{option.label}</span>

                  {option.disabled && (
                    <small
                      className="d-block mt-1 font-weight-normal text-muted"
                      style={{ fontSize: '10px', lineHeight: '1.2' }}>
                      Not available at this location
                    </small>
                  )}

                  {!option.disabled &&
                    (option.description || option.subtitle) && (
                      <small
                        className="d-block mt-1 font-weight-normal text-muted"
                        style={{ fontSize: '10px', lineHeight: '1.2' }}>
                        {option.description || option.subtitle}
                      </small>
                    )}
                </div>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

OptionAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};

export default OptionAccordion;
